






















import Vue from 'vue';

import EventBus from '@/utils/EventBus';
import Files from '@/utils/Files';

import AppFooter from '@/components/AppFooter.vue';
import AppHeader from '@/components/AppHeader.vue';
import AppModals from '@/components/AppModals.vue';
import AppOverlay from '@/components/AppOverlay.vue';
import AppSnackbars from '@/components/AppSnackbars.vue';
import CrashReport from '@/components/CrashReport.vue';

export default Vue.extend({
    components: {
        AppFooter,
        AppHeader,
        AppModals,
        AppOverlay,
        AppSnackbars,
        CrashReport,
    },
    data: () => ({ ready: false }),
    created() {
        EventBus.once('application-ready', () => this.ready = true);
    },
    mounted() {
        Files.setInput(this.$refs['file-picker'] as HTMLInputElement);
    },
});
